<template>
    <div class="sensitiveContentWrapper">
        <Button
            appearance="secondary"
            size="small"
            prefixIcon="visibility"
            @click.native.prevent
            @click="$emit('displayMedia')">
            Show sensitive content
        </Button>
        <p class="description">
            This content was marked as sensitive and is hidden by default.
        </p>
        <router-link class="settingsLink"
            to="/settings"
            v-if="auth.id">
            You can set to show sensitive content by default in the settings
        </router-link>
    </div>
</template>

<script>
    export default {
        name: 'SensitiveOverlay'
    }
</script>

<style scoped lang="scss">
    .sensitiveContentWrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 40rem;
        width: 100%;
        padding: 2rem;
        z-index: 1;
    }

    .settingsLink {
        font-size: 1rem;
        text-align: center;
    }

    .description {
        text-align: center;
    }
</style>